import { UserRole } from '@/models/User';
import {
  BillingFailedTransactions,
  BillingHome,
  BillingInvoiceDetails,
  BillingInvoiceList,
  BillingPrices,
  Home,
  OrganizationAdd,
  OrganizationEdit,
  OrganizationList,
  RetailerAdd,
  RetailerEdit,
  RetailerList,
  StoreAdd,
  StoreEdit,
  StoreList,
  SupplierAdd,
  SupplierEdit,
  SupplierList,
  SupplierToRetailerAdd,
  SupplierToRetailerEdit,
  SupplierToRetailerList,
  SupplierToStoreAdd,
  SupplierToStoreEdit,
  SupplierToStoreList,
  UserAdd,
  UserEdit,
  UserList,
} from '@/modules/admin/pages';
import Profile from '@/modules/admin/pages/Settings/Profile';
import Settings from '@/modules/admin/pages/Settings/Settings';
import {
  AdminBillingFailedTransactionsPath,
  AdminBillingHomePath,
  AdminBillingInvoiceDetailsPath,
  AdminBillingInvoiceListPath,
  AdminBillingPricesPath,
  AdminHomePath,
  AdminSettingsPath,
  AdminStoreListPath,
  OrganizationAddPath,
  OrganizationEditPath,
  OrganizationListPath,
  RetailerAddPath,
  RetailerEditPath,
  RetailerListPath,
  RetailerStoreAddPath,
  RetailerStoreEditAddressPath,
  RetailerStoreEditPath,
  RetailerStoreListPath,
  StoreEditAddressPath,
  StoreEditPath,
  SupplierAddPath,
  SupplierEditPath,
  SupplierEditSectionPath,
  SupplierListPath,
  SupplierToRetailerAddPath,
  SupplierToRetailerEditPath,
  SupplierToRetailerListPath,
  SupplierToStoreAddPath,
  SupplierToStoreEditPath,
  SupplierToStoreListPath,
  UserAddPath,
  UserEditPath,
  UserListPath,
} from '@/modules/admin/paths';
import PrivateRoute from '@/modules/auth/components/PrivateRoute';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import Currency from '@/modules/settings/pages/Currency';
import Language from '@/modules/settings/pages/Language';
import { Routes as ReactRoutes, Route } from 'react-router-dom';

const Routes = () => {
  const { role } = useAuth();

  return (
    <ReactRoutes>
      <Route element={<PrivateRoute />}>
        {role === UserRole.SystemAdmin && (
          <Route>
            <Route path={AdminHomePath} Component={Home} />
            <Route path={AdminBillingHomePath} Component={BillingHome} />
            <Route path={AdminBillingPricesPath} Component={BillingPrices} />
            <Route
              path={AdminBillingFailedTransactionsPath}
              Component={BillingFailedTransactions}
            />
            <Route path={AdminBillingInvoiceListPath} Component={BillingInvoiceList} />
            <Route path={AdminBillingInvoiceDetailsPath.path} Component={BillingInvoiceDetails} />
            <Route path={AdminStoreListPath} Component={StoreList} />
            <Route Component={Settings}>
              <Route path={AdminSettingsPath.profile} Component={Profile} />
              <Route path={AdminSettingsPath.currency} Component={Currency} />
              <Route path={AdminSettingsPath.language} Component={Language} />
            </Route>
            <Route path={OrganizationListPath} Component={OrganizationList} />
            <Route path={OrganizationAddPath} Component={OrganizationAdd} />
            <Route path={OrganizationEditPath.path} Component={OrganizationEdit} />
            <Route path={UserListPath} Component={UserList} />
            <Route path={UserAddPath} Component={UserAdd} />
            <Route path={UserEditPath.path} Component={UserEdit} />
            <Route path={RetailerListPath} Component={RetailerList} />
            <Route path={RetailerAddPath} Component={RetailerAdd} />
            <Route path={RetailerEditPath.path} Component={RetailerEdit} />
            <Route path={SupplierListPath} Component={SupplierList} />
            <Route path={SupplierAddPath} Component={SupplierAdd} />
            <Route path={SupplierEditPath.path} Component={SupplierEdit} />
            <Route path={SupplierEditSectionPath.path} Component={SupplierEdit} />
            <Route path={RetailerStoreListPath.path} Component={StoreList} />
            <Route path={StoreEditPath.path} Component={StoreEdit} />
            <Route path={StoreEditAddressPath.path} Component={StoreEdit} />
            <Route path={RetailerStoreAddPath.path} Component={StoreAdd} />
            <Route path={RetailerStoreEditPath.path} Component={StoreEdit} />
            <Route path={RetailerStoreEditAddressPath.path} Component={StoreEdit} />
            <Route path={SupplierToRetailerListPath.path} Component={SupplierToRetailerList} />
            <Route path={SupplierToRetailerAddPath.path} Component={SupplierToRetailerAdd} />
            <Route path={SupplierToRetailerEditPath.path} Component={SupplierToRetailerEdit} />
            <Route path={SupplierToStoreListPath.path} Component={SupplierToStoreList} />
            <Route path={SupplierToStoreAddPath.path} Component={SupplierToStoreAdd} />
            <Route path={SupplierToStoreEditPath.path} Component={SupplierToStoreEdit} />
          </Route>
        )}
      </Route>
    </ReactRoutes>
  );
};

export default Routes;
